import { render, staticRenderFns } from "./SemenDestructionProposal.vue?vue&type=template&id=c1df3214&scoped=true&"
import script from "./SemenDestructionProposal.vue?vue&type=script&lang=js&"
export * from "./SemenDestructionProposal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1df3214",
  null
  
)

export default component.exports